export default "__VITE_ASSET__e04c7868__"